import { lazy } from 'react';

const CircularityCertificatesAdminConfig = {
	settings: {
		layout: {
			config: { footer: { display: false } }
		}
	},
	routes: [
		{
			path: '/adm/consult/circularity-certificates',
			component: lazy(() => import('./CircularityCertificatesContainer'))
		}
	]
};

export default CircularityCertificatesAdminConfig;
